import WisnioLogo from "images/logo/default/wisnio-logo-full.svg?react";
import AssessioLogo from "images/logo/default/assessio.svg?react";

const headerLogosMap = {
  default: WisnioLogo,
  assessio: AssessioLogo,
};

export default headerLogosMap;
